<form  nz-form style="padding-top:12px;padding-right:12px" class="detail-mail" autocomplete="off">
  <div nz-row [nzGutter]="['0','0']">
 
    <div nz-col nzSm="24" nzMd="24">
      <nz-card class="mail-card">
        <div nz-row [nzGutter]="['24','12']">
          <div nz-col nzSm="21" nzMd="21" *ngIf="value.title">
            <nz-form-item>
              <span class="title">
                <strong>{{ value.title }}</strong>
              </span>
            </nz-form-item>
          </div> 
          <nz-divider></nz-divider> 
          <div nz-col nzSm="21" nzMd="21">
            <nz-form-item> 
                <span>
                   <strong>Người tạo: </strong> {{schoolName}}
                </span> 
            </nz-form-item>
          </div> 
          <nz-divider></nz-divider> 
          <div nz-col nzSm="24" nzMd="24" *ngIf="!value.tagName">
            <nz-form-item>
              <span class="content grey"><strong>Ngày bắt đầu:</strong> {{value.startDate | date:'dd/MM/yyyy'}}</span>
 
            </nz-form-item >
            <nz-form-item>  
              <span class="content grey"><strong>Ngày hết hạn: </strong>{{value.expirationDate | date:'dd/MM/yyyy'}}</span>
            </nz-form-item >
            
          </div>
          <nz-divider></nz-divider>
          <div nz-col nzSm="24" nzMd="24"> 
            <strong>Nội dung:</strong>
            <div nz-col nzSm="24" nzMd="24" [innerHTML]="value.content"></div>
          </div>
          <nz-divider></nz-divider>
          <div nz-col nzSm="24" nzMd="24">
            <span class="text-file"><strong>Đính kèm</strong>&nbsp;({{fileList.length}})</span>
          </div>
          <div nz-col nzSm="24" nzMd="24">
            <nz-upload [nzFileList]="fileList" [nzShowButton]="false" [nzShowUploadList]="{ showRemoveIcon: false, showDownloadIcon : true }" [nzDownload]="downloadfile">
              <button nz-button><i nz-icon nzType="upload"></i>Upload</button>
            </nz-upload>
          </div>
        </div>
      </nz-card>
    </div>
  </div>
  <div *nzModalFooter>
    <button nz-button (click)="close()">Đóng</button>
  </div>
</form>
 